module.exports = __webpack_public_path__ + "img/simen-pro.c2983e87.jpg";